import React from 'react';
import type { Pages } from '../types';

interface PaginationContextShape {
    page: Pages;
    setPage: (page: Pages) => void;
}

export const PaginationContext = React.createContext<PaginationContextShape | undefined>(undefined);

interface PaginationProviderProps {
    page: Pages;
}

export const PaginationDisplayContext = React.createContext<
    Partial<PaginationContextShape>
>({});

export const usePaginationDisplayContext = () => {
    const value = React.useContext(PaginationDisplayContext);

    if (value === undefined) {
        throw new Error(
            'usePaginationDisplayContext must be used within PaginationDisplayProvider',
        );
    }

    return value;
};

export const PaginationProvider: React.FC<React.PropsWithChildren<PaginationProviderProps>> = ({ children, page }) => {
    const [currentPage, setCurrentPage] = React.useState<Pages>(page);

    return (
        <PaginationDisplayContext.Provider
            value={{
                page: currentPage,
                setPage: setCurrentPage,
            }}
        >
            {children}
        </PaginationDisplayContext.Provider>
    );
};
